export const projects = [
  {
    title: " Food-Recipes",
    repository: "https://github.com/FediRouatbi/food_recipes",
    link: "https://food-recipes-mu.vercel.app/",
    tools: [
      "NextJs",
      "Redux",
      "Mongoose",
      "Firebase",
      "TailwindCSS",
      "Framer Motion",
    ],

    introduction:
      " A fully Responsive CRUD App allow users to  create or find specific recipe  , comment on recipe ,create an account ",
    img: "food-recipes.png",
  },
  {
    title: "Expense Tracker ",
    repository: "https://github.com/FediRouatbi/expense-tracker-v2",
    link: "https://expeense-tracker-v2.netlify.app/",
    tools: [
      "ReactJS",
      "React Router",
      "Firebase",
      "Chart.js",
      "Tailwind",
      "daisyUI",
    ],
    introduction:
      " A fully Responsive CRUD App   built  with Firebase allow you to have a better view on your expenses by shoing curbe of last week exspenses and incoms ",
    img: "expense.jpg",
  },
  {
    title: "matching game pokemon",
    repository: "https://github.com/FediRouatbi/matchingGame",
    link: "https://matching-game-gules.vercel.app/",
    tools: ["vite", "ReactJS", "Redux", "Typescript"],
    introduction: "A fully Responsive matching game  ",
    img: "matching-game.png",
  },
  {
    title: "Mapty",
    repository: "https://github.com/FediRouatbi/Expense-Tracker",
    link: "https://mapty-v0.netlify.app/",
    tools: ["js"],
    introduction: "A  leaflet Map where you can plan for a race or cycling   ",
    img: "mapty.png",
  },
  {
    title: "ti tac toe  ",
    repository: "https://github.com/FediRouatbi/ti-tac-toe-game",
    link: "https://tic-tac-toe-v0.netlify.app/",
    tools: ["reactJS", "react router", "css"],
    introduction:
      "Tic tac toe game with the ability to come back historically and play the game in a different way.",
    img: "tic-tac-toe.png",
  },
  {
    title: "GithubFinder",
    repository: "https://github.com/FediRouatbi/GithubFinder",
    link: "https://github-finder-v00.netlify.app/",
    tools: ["reactJS", "useReducer", "Tailwind", "Daisyui", "react router"],
    introduction:
      " A fully Responsive App  that works with the GitHub users API to pull profile data and display it",
    img: "github-finder.png",
  },
  {
    title: "expense tracker ",
    repository: "https://github.com/FediRouatbi/expense-tracker-react ",
    link: "https://expense-tracker-react-v0.netlify.app/",
    tools: ["reactJS"],
    introduction:
      "Provide you with an overview of your balance, revenue, expenses with the ability to delete and add a new transaction",
    img: "expense-tracker.png",
  },
  {
    title: "Calculator",
    repository: "https://github.com/FediRouatbi/Calculator",
    link: "https://calculator-v0.netlify.app/",
    tools: ["reactJS", "react router", "css"],
    introduction: "A simple Caluculator including 3 themes and navigation",
    img: "calculator.png",
  },
  {
    title: "Nintendo ",
    repository: "https://github.com/FediRouatbi/Nintendo-clone",
    link: "https://nintendo-clone.vercel.app/",
    tools: ["Vite", "ReactJS", "TailwindCSS"],
    introduction:
      " Nintendo clone Landing page build with mobile-first approach ",
    img: "nintendo.png",
  },

  {
    title: "feedback App ",
    repository: "https://github.com/FediRouatbi/feedbackApp",
    link: "https://feedbackapp-v0.netlify.app/",
    tools: ["reactJS", "react router", "css"],
    introduction:
      "Web page that allows you to put your comments with the ability to edit and delete using localstorage to save data",
    img: "feedback-app.png",
  },

  {
    title: "Authentication",
    repository: "https://github.com/FediRouatbi/React-Authentication",
    link: "https://authentication-firebase-v0.netlify.app/",
    tools: ["reactJS", "React Router", "firebase", "css", "tailwind"],
    introduction:
      "Login / Signup with Email & Password with ability to reset , change password ",
    img: "authentication.png",
  },

  {
    title: "IP Address Tracker",
    repository: "https://github.com/FediRouatbi/IP-Address-Tracker-",
    link: "https://ip-address-tracker-v0.netlify.app/",
    tools: ["reactJS", "sass"],
    introduction:
      "A challange from frontendmentor, by typing the ip address you will be able to know some information about it using an API",
    img: "address-tracker.png",
  },

  {
    title: "Ecommerce",
    repository: "https://github.com/FediRouatbi/Ecommerce",
    link: "https://ecommerce-v0.netlify.app/",
    tools: ["reactJS", "React Router", "css", "sass"],
    introduction:
      "A frontendmentor challange , home page for the business of selling sneakers",
    img: "sneakers.png",
  },

  {
    title: "forkify",
    repository: "https://github.com/FediRouatbi/Expense-Tracker",
    link: "https://forkify-app-v0.netlify.app/",
    tools: ["js"],
    introduction:
      "Frokify is an app that allows you to serach for a  pizza recipe using an API  ",
    img: "forkify.png",
  },

  {
    title: "Happy new year",
    repository: "https://github.com/FediRouatbi/Happy-new-year",
    link: "https://happy-new-year-v0.netlify.app/",
    tools: ["html", "css", "js"],
    introduction:
      "A simple webpage that tells how much remains for the New Year 🎉",
    img: "happy-new-year.png",
  },

  {
    title: "Bankist home page",
    repository: "https://github.com/FediRouatbi/Bankist-home-page",
    link: "https://bankist-home-page.netlify.app/",
    tools: ["html", "css"],
    introduction: "Web page for banker",
    img: "bankist.png",
  },
  {
    title: "Bankist users accounts",
    repository: "https://github.com/FediRouatbi/Bankist-users-accounts",
    link: "https://bankist-users-accounts.netlify.app/",
    tools: ["js"],
    introduction:
      "The user interface of accounts for bankist that allow you to transfer money, ask for a loan or close the account.",

    img: "bankist-users.png",
  },
  {
    title: "Guess My Number",
    repository: "https://github.com/FediRouatbi/Guess-My-Number",
    link: "https://guess-my-number-v0.netlify.app/",
    tools: ["js"],
    introduction:
      "The game is to guess a random number  in range 1 – 20 in minimum number of Guesses.",
    img: "geuss-number.png",
  },
  {
    title: "pig game",
    repository: "https://github.com/FediRouatbi/pig-game",
    link: "https://pig-game-v0.netlify.app/",
    tools: ["js"],
    introduction:
      " Players  roll the dice as many times as they want, adding all roll results to a running total, but losing your gained score for the turn if you roll a 1. player who reaches 100 points first wins the game",
    img: "pig.png",
  },

  {
    title: "small Weather App  ",
    repository:
      "https://github.com/FediRouatbi/A-small-Weather-App-in-React-JS",
    link: "https://check-weather-v0.netlify.app/",
    tools: ["reactJS", "css"],
    introduction:
      "A simple weather app allows you to verify the weather around the world with a third-party API",
    img: "weather-app.png",
  },
  {
    title: "Omnifood",
    repository: "https://github.com/FediRouatbi/Omnifood",
    link: "https://omnifood-v0.netlify.app/",
    tools: ["html", "css", "js"],
    introduction: "A simple web page for selling healthy food online ",
    img: "omnifood.png",
  },
];
